import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast  } from "react-toastify";

export const updatePayout = createAsyncThunk("user/updatePayout", async (payload) => {

  const response = await api.put("admin/payouttable/update", payload);
 
  return response.data;
});

const updatePayoutSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatePayout.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatePayout.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
        console.log(36, action.payload)
        toast.success(action.payload.message)
      })
      .addCase(updatePayout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default updatePayoutSlice.reducer;
